import React, { Component } from "react";
import PropTypes from "prop-types";

import styles from "./Cells.css";

import {
  TYPES,
  TYPE_CHAR,
  TYPE_CLUE,
  TYPE_PRE,
  BOX_SIZE
} from "../../constants";

import CellContainer from "./Cells/CellContainer";
import Clue from "./Cells/Clue/Clue";
import Char from "./Cells/Char/Char";
import Prefilled from "./Cells/Prefilled/Prefilled";
import Direction from "./Cells/Direction/Direction";

export default class Cells extends Component {
  static defaultProps = {
    editable: true
  };

  static propTypes = {
    id: PropTypes.string,
    editable: PropTypes.bool,
    loaded: PropTypes.bool,
    size: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    }),
    data: PropTypes.arrayOf(
      PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
        type: PropTypes.oneOf(TYPES)
      })
    )
  };

  renderCells = () => {
    const { editable, data, id } = this.props;

    return data.map(cell => {
      const { x, y, type } = cell;
      const key = `box-${id}/${x}/${y}`;

      switch (type) {
        case TYPE_CHAR:
          return (
            <CellContainer
              component={Char}
              key={key}
              x={x}
              y={y}
              editable={editable}
            />
          );

        case TYPE_PRE:
          return (
            <CellContainer
              component={Prefilled}
              key={key}
              x={x}
              y={y}
              editable={editable}
            />
          );

        case TYPE_CLUE:
          return <CellContainer component={Clue} key={key} x={x} y={y} />;

        default:
          return null;
      }
    });
  };

  renderCellDirections = () => {
    const { editable, data, id } = this.props;

    return data.filter(cell => cell.type === TYPE_CLUE).map(cell => {
      const { x, y } = cell;
      const key = `direction-${id}/${x}/${y}`;

      return (
        <CellContainer
          component={Direction}
          key={key}
          x={x}
          y={y}
          editable={editable}
        />
      );
    });
  };

  render = () => {
    const { loaded, size } = this.props;

    if (loaded) {
      const width = size.x * BOX_SIZE + 10;
      const height = size.y * BOX_SIZE + 10;

      return (
        <svg
          version="1.1"
          viewBox={`-5 -5 ${width} ${height}`}
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          preserveAspectRatio="xMidYMid meet"
          className={styles.cells}
          style={{
            minWidth: size.x >= 7 && size.x * BOX_SIZE,
            minHeight: size.y >= 7 && size.y * BOX_SIZE
          }}
        >
          {this.renderCells()}
          {this.renderCellDirections()}
        </svg>
      );
    }
    return <svg />;
  };
}



// WEBPACK FOOTER //
// ./src/components/Cells/Cells.js